import {FC, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {offersAndroidApp} from '../core/androidApp'
import {promptInstall} from '../core/installPrompt'
import {
  installedAppIcon,
  installedAppName,
  installOfferLine,
  thisDevice,
  useInstallState,
} from '../core/useInstallState'
import {InstallGuideDialog} from './InstallGuideDialog'
import '../installApp.scss'

/**
 * The sign-in page's install box, under the form: always there while the panel is not installed
 * on this device (no «later» here), with one-click install where the browser offers it and the
 * device's own guide otherwise.
 */
export const InstallLoginBox: FC = () => {
  const {prompt, detected, guide, installed} = useInstallState()
  const [open, setOpen] = useState(false)

  if (installed) return null

  // On an Android phone the guide comes first: it offers the Android app, then the web app.
  const androidApp = offersAndroidApp(detected)
  const install = async () => {
    if (androidApp || !prompt.canPrompt) {
      setOpen(true)
      return
    }
    await promptInstall()
  }

  return (
    <>
      <section className='ia-login' aria-labelledby='ia-login-title'>
        <img
          className='ia-login__icon'
          src={toAbsoluteUrl(installedAppIcon())}
          alt=''
          width={42}
          height={42}
        />
        <div className='ia-login__text'>
          <strong id='ia-login-title'>
            {installedAppName()} را روی {thisDevice(detected)} نصب کنید
          </strong>
          <span>{installOfferLine(detected, guide)}</span>
        </div>
        <button
          type='button'
          className='btn btn-sm btn-light-primary ia-login__action'
          onClick={install}
        >
          {androidApp ? 'دریافت برنامه' : prompt.canPrompt ? 'نصب' : 'راهنمای نصب'}
        </button>
      </section>
      <InstallGuideDialog show={open} onClose={() => setOpen(false)} />
    </>
  )
}
